module.exports = __webpack_public_path__ + "static/logo_new-year.67d0b049.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_new-year.svg
// module id = 252
// module chunks = 35783957827783 162898551421021